
import { Vue } from "vue-class-component";

export default class CalendarPlus extends Vue {}
